import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import HomeCardComponent from "./HomeCardComponent";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link, useNavigate } from "react-router-dom";

function SectionHome({ data, title, description, icon, type }) {
  return (
    <Stack component="section" mb={7}>
      <Stack component="header" mb={3}>
        {/* <Typography
          component="span"
          fontSize="small"
          sx={{
            backgroundColor: "#E5E7EB",
            color: "#474747",
            py: 0.5,
            px: 2,
            width: "fit-content",
            marginInline: "auto",
            borderRadius: 3,
            mb: 1,
          }}
        >
          {title}
        </Typography> */}
        <Box mb={1} sx={{ color: "text.textPropProject" }}>
          <Typography
            component="h2"
            variant="h4"
            sx={{
              fontWeight: "700",
              fontFamily: "Inter",
              color: "#000003",
              textAlign: "center",
            }}
          >
            {title === "Proyectos"
              ? "Proyectos"
              : "Encuentra tu hogar ideal"}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontWeight: "normal",
            textAlign: "center",
            maxWidth: { xs: "100%", md: "80%" },
            marginInline: "auto",
            mb: 3,
            color: "GrayText",
          }}
        >
          {description}
        </Typography>
      </Stack>
      <Stack
        mb={3}
        component="section"
        sx={{ width: "90%", marginInline: "auto", mb: 4 }}
      >
        <Grid container columns={3} spacing={{ xs: 3, md: 4, lg: 7 }}>
          {data.length === 0 ? (
            title === "Propiedades" ? (
              <Grid item xs={3} lg={3}>
                <Typography sx={{ textAlign: "center", color: "GrayText" }}>
                  No hay inmuebles
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={3} lg={3}>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "GrayText",
                    marginInline: "auto",
                  }}
                >
                  No hay proyectos
                </Typography>
              </Grid>
            )
          ) : (
            ""
          )}

          {(data || []).map((element, index) => {
            return <HomeCardComponent data={element} key={index} type={type} />;
          })}
        </Grid>
      </Stack>
      <Button
        sx={{
          textTransform: "none",
          width: 250,
          marginInline: "auto",
          border: "1px solid #b5b5b542",
        }}
        LinkComponent={Link}
        to={title === "Propiedades" ? "/property" : "/projects"}
        href={title === "Propiedades" ? "/property" : "/projects"}
      >
        Explorar más {title === "Propiedades" ? "propiedades" : "proyectos"}
        <ChevronRightIcon />
      </Button>
    </Stack>
  );
}

export default SectionHome;
